export enum SocialMediaProvider {
  FACEBOOK = 'facebook',
  APPLE = 'apple',
}
